<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
.title-div {
  font-weight: 600;
  margin: 20px 0;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}
</style>

<template>
  <div>
      <div class="title-div">充电信息</div>
      <!-- 表格 -->
        <ZD-table
          :tableColumns="pageConfig.chargeListColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.pileTableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      <!-- 分页 -->
      <!-- <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div> -->
      <div class="text-right margin-t-20" v-if="isCustInfo">
        <button class="common-empty-button" @click="back()">返 回</button>
      </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      showMultiQuerys:false,//高级筛选
      queryInfo: {}, //标签页 搜索字段
      labelVisible: false, //标签管理弹窗
      dealerVisible: false, //分配运营商弹窗
      selectLabelVisible: false, //选择标签弹窗
      labelName: "11", //	未使用
      labelForm: {}, //标签管理内容
      dealerForm: {}, //分配运营商内容
      checkList: [], //选中标签
      labelsArr: [], //客户标签
      selectLabelForm: {}, //所有标签内容
      labelSum: 0, //合计客户数量 默认0
      operates: {
        width: 220,
        fixed: "right",
        list: [],
      },
      searchTime: [], //注册时间
      firstSearchTime: [], //首次充电时间
      lastSearchTime: [], //最近充电时间
      options: [], //未使用
      value: [], //未使用
      pileList: [], //桩列表
      loading: false, //未使用
      dealNameArr: [], //未使用
      dealerList: [], //未使用
      custInfo:{},
      isCustInfo: false,
    };
  },
  methods: {
    init() {
      // this.getPileList();
      if(this.$store.state.custObj){
        this.custInfo = this.$store.state.custObj
        this.getListData(this.pagination, true);
        this.isCustInfo = true
      }else if(this.$store.state.pileObj){
        this.custInfo = this.$store.state.pileObj
        this.getList(this.pagination, true);
        this.isCustInfo = false
      }
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      // _.queryInfo.corpNo = _.$store.state.corpNo;
      // _.$H.post(_, _.$A.cust.pagecust, _.queryInfo).then((res) => {
      _.$H.post(_, _.$A.cust.getPileOrder, {custPhone:_.custInfo.mobile}).then((res) => {
        console.log(res);
        _.tableData = res.data.data || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    // 获取表格数据
    getList(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      // _.queryInfo.corpNo = _.$store.state.corpNo;
      // _.$H.post(_, _.$A.cust.pagecust, _.queryInfo).then((res) => {
      _.$H.post(_, _.$A.cust.getPileOrder, {pileCode:_.custInfo.pileCode}).then((res) => {
        console.log(res);
        _.tableData = res.data.data || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    back(){
      if(this.isCustInfo){
        this.$router.push({
          name: "custList"
        })
      }
      // this.$router.go(-1)
    },
  },
  mounted() {
    this.init();
  },
};
</script>
